import ReactLoading from "react-loading";
import { useSelector } from "react-redux";

export default function CircularIndeterminate() {
  const appState = useSelector((state) => state);

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "100vh" }}
    >
      <ReactLoading className="mx-auto" type="spin" color="#00000" />
    </div>
  );
}
